import ChapterContainer from './chapter_container';

const Chapter = ChapterContainer;
export default Chapter;
